module.exports = require('./compiled');